import styled, { css } from 'styled-components'

import blur from '@/assets/blur.svg'
import { rgba } from 'polished'

export const Container = styled.div`
  width: 100%;
  /* height: 100%; */

  /* overflow-x: hidden; */
  /* background: ${props => props.theme.colors.background.dark}; */

  .container {
    width: 1120px;
    margin: 0 24px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .divider {
    width: 100%;
    height: 1px;
    margin-top: 10px;
    align-self: stretch;
    border-bottom: 1px dashed
      ${props => rgba(props.theme.colors.text.light, 0.4)};
  }
  .title {
    font-size: 64px;
    /* font-family: Roboto, arial, helvetica; */
    font-style: normal;
    font-weight: 600;

    line-height: 67px;
    color: ${props => props.theme.colors.text.light};
  }
  .titleSection {
    font-size: 2.8rem;
    font-weight: 700;
    line-height: 60px;
    color: ${props => props.theme.colors.text.light};
    margin-bottom: 1rem;
  }
  .subTitleSection {
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 34px;
    color: ${props => props.theme.colors.text.light};
  }
  .paragraph {
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    color: ${props => rgba(props.theme.colors.text.light, 0.6)};

    margin-top: 4px;
    margin-bottom: 10px;
  }

  .hero-role {
    margin: 0 0 1rem;
    color: ${props => props.theme.colors.primary.normal};
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.5;
  }

  .hero-copy {
    max-width: 680px;
  }

  .hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin: 1.75rem 0 2.5rem;

    a {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.8rem 1.1rem;
      border: 1px solid ${props => rgba(props.theme.colors.white, 0.16)};
      border-radius: 999px;
      color: ${props => props.theme.colors.text.light};
      font-size: 0.95rem;
      font-weight: 700;
      text-decoration: none;
      transition: all 0.25s ease;

      &:first-child {
        border-color: transparent;
        background: ${props => props.theme.colors.primary.normal};
      }

      &:hover {
        transform: translateY(-2px);
        border-color: ${props => props.theme.colors.primary.normal};
      }
    }
  }

  .metrics {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
    max-width: 700px;

    div {
      padding-top: 1rem;
      border-top: 1px solid ${props => rgba(props.theme.colors.white, 0.14)};
    }

    strong,
    span {
      display: block;
    }

    strong {
      color: ${props => props.theme.colors.text.light};
      font-size: 1.8rem;
    }

    span {
      margin-top: 0.2rem;
      color: ${props => rgba(props.theme.colors.text.light, 0.55)};
      font-size: 0.85rem;
      line-height: 1.35;
    }
  }

  .experience-grid,
  .project-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
    width: 100%;
    margin-top: 2.5rem;
  }

  .experience-card,
  .project-card {
    padding: 1.25rem;
    border: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};
    border-radius: 8px;
    background: ${props => rgba(props.theme.colors.white, 0.02)};
  }

  .experience-card {
    span,
    strong {
      color: ${props => props.theme.colors.primary.normal};
      font-size: 0.8rem;
      font-weight: 800;
    }

    h3 {
      margin: 0.7rem 0 0.35rem;
      color: ${props => props.theme.colors.text.light};
      font-size: 1.1rem;
      line-height: 1.3;
    }

    strong {
      color: ${props => rgba(props.theme.colors.text.light, 0.7)};
      font-size: 0.9rem;
    }

    p {
      margin: 0.9rem 0 0;
      color: ${props => rgba(props.theme.colors.text.light, 0.58)};
      font-size: 0.95rem;
      line-height: 1.55;
    }
  }

  .project-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin: 2rem 0 5rem;
  }

  .project-card {
    color: inherit;
    text-decoration: none;
    transition: all 0.25s ease;

    &:hover {
      transform: translateY(-4px);
      border-color: ${props => props.theme.colors.primary.normal};
    }

    span {
      color: ${props => props.theme.colors.primary.normal};
      font-size: 0.75rem;
      font-weight: 800;
      text-transform: uppercase;
    }

    h3 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.5rem;
      margin: 0.7rem 0 0;
      color: ${props => props.theme.colors.text.light};
      font-size: 1.05rem;
    }

    p {
      margin: 0.8rem 0 0;
      color: ${props => rgba(props.theme.colors.text.light, 0.58)};
      font-size: 0.9rem;
      line-height: 1.45;
    }
  }

  .hobbies-title {
    margin-top: 2rem;
  }

  .social-network-link {
    cursor: pointer;

    .social-network-link-hit {
      fill: transparent;
      stroke: transparent;
    }
  }

  .social-network-item,
  .social-network-link-content {
    transition: transform 0.2s ease;
    transform-box: fill-box;
    transform-origin: center;
  }

  .social-network-item.is-active,
  .social-network-link-content.is-active {
    transform: scale(1.08);
  }

  .social-network-link-legacy {
    display: none;
  }

  .social-network-link-badge {
    circle {
      fill: ${props => props.theme.colors.background.normal};
    }

    .social-network-link-icon rect {
      fill: none;
      stroke: ${props => props.theme.colors.primary.normal};
      stroke-width: 3;
    }

    .social-network-link-icon path {
      fill: none;
      stroke: ${props => props.theme.colors.primary.normal};
      stroke-width: 3;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    text {
      fill: ${props => props.theme.colors.text.light};
      font-family: inherit;
      font-size: 24px;
      font-weight: 800;
    }

    .social-network-link-label {
      fill: ${props => props.theme.colors.primary.normal};
      font-size: 14px;
      letter-spacing: 3px;
    }

    .social-network-link-handle {
      fill: ${props => props.theme.colors.text.light};
      font-size: 11px;
      font-weight: 400;
      letter-spacing: 1px;
    }
  }
  section {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;

    &:nth-of-type(1) {
      align-items: center;

      padding-top: 56px;
      padding-bottom: 130px;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        display: block;

        width: 100%;
        min-height: 100vh;

        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 50%,
            ${props => rgba(props.theme.colors.background.dark, 0.8)} 100%
          ),
          url('/images/CM.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 80%;

        opacity: 0.2;
        z-index: 0;
      }

      & > div {
        padding: 0 2rem;

        .title-box {
          width: 100%;
          max-width: 55%;
          margin-top: 0;

          .nick {
            margin-bottom: 10px;

            color: ${props => props.theme.colors.primary.normal};

            font-size: 18px;
            font-weight: 800;
          }
        }
      }
    }

    &:nth-of-type(2) {
      padding-top: 130px;
      min-height: 70vh;

      & > div {
        padding: 0 2rem;

        .paragraph {
          width: 100%;
          max-width: 640px;
        }

        .experience-grid {
          max-width: 1120px;
        }
      }
    }

    &:nth-of-type(3) {
      position: relative;
      left: 0rem;
      width: 100vw;

      & > div {
        width: 100%;
        /* padding: 0 2rem; */
        margin: 0;

        .content {
          width: 100%;
          max-width: 1120px;
          margin: auto;
          padding: 0 calc(2rem + 24px);
          /* margin: 0 ; */

          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
      }
    }

    &:nth-of-type(4) {
      padding-bottom: 100px;

      & > div {
        padding: 0 2rem;

        & > svg {
          position: sticky;
          top: 0;
          right: 6%;
          width: 100%;
          margin-bottom: -100%;
          /* margin-top: -50%; */

          transform: translate(50%, -25%);
        }

        .paragraph {
          width: 100%;
          max-width: 640px;
        }
      }
    }

    &:nth-of-type(5) {
      padding-top: 56px;
      padding-bottom: 130px;

      & > div {
        padding: 0 2rem;
        label {
          margin-bottom: 10px;

          color: ${props => props.theme.colors.primary.normal};

          font-size: 18px;
          font-weight: 800;
        }
        svg {
          width: 100%;
          max-width: 700px;
          margin: auto;
          margin-top: 4rem;

          &.social-network {
            z-index: 10;
          }
        }
      }
    }

    &:nth-of-type(6) {
      padding-top: 130px;
      padding-bottom: 56px;

      & > div {
        width: 100%;
        max-width: 700px;

        flex-wrap: wrap;
        align-items: center;

        label,
        h1,
        p {
          text-align: center;
        }

        label {
          margin-bottom: 10px;

          color: ${props => props.theme.colors.primary.normal};

          font-size: 14px;
          font-weight: 800;
        }

        p {
          margin: 10px 0px 10px 0px;

          font-size: 16px;
          letter-spacing: 1px;
        }

        .button {
          width: 100%;
          max-width: 300px;
          height: 4rem;
          margin: 10px 0px 10px 0px;

          font-weight: 600;
          font-size: 1rem;

          background: linear-gradient(
            45deg,
            ${props => props.theme.colors.primary.normal},
            ${props => props.theme.colors.secondary} 100%
          );
        }
      }
    }

    @media (max-width: 600px) {
      & > .container {
        padding: 0 !important;
      }

      &:nth-of-type(1) {
        &:before {
          background-size: 100%;
        }
      }
      &:nth-of-type(2) {
        min-height: 90vh;
      }

      .metrics,
      .experience-grid,
      .project-grid {
        grid-template-columns: 1fr;
      }

      .metrics {
        gap: 0.7rem;
      }

      .project-grid {
        margin-bottom: 3rem;
      }
      &:nth-of-type(3) {
        left: 0;
      }
      &:nth-of-type(4) {
        & > div svg {
          width: 200%;
          margin-bottom: -200%;

          transform: translate(0%, -25%);
        }
      }
    }
  }
`

export const HorizontalSection = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  margin-top: 4rem;

  .container {
    position: relative;
    min-height: 100%;
    max-height: 100%;
    padding: 0 0 0 150px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  @media (max-width: 600px) {
    .container {
      padding: 0 0 0 2rem;
    }
  }
`

export const Hobbies = styled.div`
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 56px;

  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);

  word-break: break-word;
  grid-gap: 80px 32px;
  gap: 80px 32px;

  @media (max-width: 900px) {
    grid-gap: 72px 32px;
    gap: 72px 32px;
    margin-top: 32px;
    grid-template-columns: repeat(1, 1fr);
  }

  .hobbie {
    width: 100%;
    height: 100%;
    max-width: 100%;

    background-color: ${props => rgba(props.theme.colors.white, 0.01)};
    backdrop-filter: blur(10px);
    color: ${props => rgba(props.theme.colors.text.light, 0.6)};
    border: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};
    /* box-shadow: rgb(0 0 0 / 70%) 7px 7px 7px -7px; */
    border-radius: 5px;

    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.02);
      border: 2px solid ${props => props.theme.colors.primary.normal};
    }
    .hobbie-header,
    .hobbie-content {
      padding: 0 28px 28px;
    }

    .hobbie-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      /* padding: 24px 32px; */
      padding: 16px 18px;

      position: relative;

      border-bottom: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};

      strong {
        font-weight: 600;
        font-size: 1.2rem;
        color: ${props => props.theme.colors.text.light};
      }
      span {
        font-weight: 900;
        font-size: 16px;
        line-height: 19px;
        color: ${props => props.theme.colors.text.dark};
      }
    }

    .hobbie-content {
      padding: 20px;
      display: block;

      img {
        width: 100%;
        margin: auto;
        margin-bottom: 1rem;
      }

      p {
        font-size: 18px;
        line-height: 156%;

        white-space: pre-line;
        /* text-indent: 1.2rem; */
        /* -webkit-user-modify: read-write-plaintext-only; */
      }
    }
  }
`

export const Blur = styled(blur)`
  position: absolute;
  left: auto;
  top: auto;
  right: auto;
  bottom: auto;

  width: 60%;

  filter: blur(4px);
  opacity: 0.6;
  z-index: -1;

  @media (max-width: 600px) {
    width: 200% !important;
  }
`
